import { API_URL } from '~/constants/environment'

import { Api } from '../../utils/api'

const api = new Api(API_URL, 'customers/web_flows')

export const deleteFlow = async (id: string) => {
  return api.delete({
    path: id,
  })
}
